import { LinkQueryCriteria } from './link-query-criteria';
import { Injectable } from '@angular/core';
import { CriteriaOperator } from '../operator';

@Injectable()
export class LinkQueryCriteriasBuilder {
  public items: LinkQueryCriteria[];

  constructor() {
    this.reset();
  }

  public createCriteriasQuery(): any {
    if (this.items.length === 0) {
      return undefined;
    }
    const item = this.items[0]; // TODO: Loop items
    return {
      criterias: `{"${item.propertyName || ''}": {"operator": ${item.operator || 0}, "value": ["${
        item.value || ''
      }"]}}`,
    };
  }

  public createCriteriasQueryNewCP(propertyName: string, operator: any, value: any): any {
    return {
      criterias: `{"${propertyName || ''}": {"operator": "${operator || 0}", "value": ${value}}}`,
    };
  }

  public addCriteria(item: LinkQueryCriteria) {
    this.items.push(item);
  }

  public reset() {
    this.items = [];
  }

  public createAndAddCriteria(propertyName: string, operator: number, value: string) {
    const criteria = new LinkQueryCriteria();
    criteria.propertyName = propertyName;
    criteria.operator = operator;
    criteria.value = value;
    this.addCriteria(criteria);
  }

  public static generateCriteriaQuery(propertyName: string, operator: CriteriaOperator, value: string): string {
    return `{"${propertyName || ''}": {"operator": ${operator}, "value": ["${value || ''}"]}}`;
  }
}
